<elcia-dropdown
  [control]="control()"
  [items]="plugins()"
  [label]="'product.plugin' | translate"
  [textField]="'name'"
  [valueField]="'id'"
/>
